import { useParams } from 'react-router-dom';
import Home from './Home';
import IframeEvents from './IframeEvents';
import IframeMembers from './IframeMembers';
import IframeEvent from './IframeEvent';


export default function Iframes() {
    const { page, id } = useParams();
    if (page == 'event') {
        return (
            <IframeEvent />
        );
    }
    if (page == 'events') {
        return (
            <IframeEvents />
        );
    }
    else if (page == 'members') {
        return (
            <IframeMembers />
        );
    }
    return (
        <div>

        </div>
    );
}

